












































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import MiniAppConfigPO from "@/store/entities/wechat/miniappconfigpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "../../../lib/util";
@Component({
  components: { TreeSelect },
})
export default class EditMiniAppConfig extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  entityPO: MiniAppConfigPO = new MiniAppConfigPO();
  loading: boolean = false;
  created() {
    this.getcompanytree();
    this.entityPO.isEnable = 1;
  }
  //获取公司树
  async getcompanytree() {
    await this.$store
      .dispatch("organization/getCommanySelectTree")
      .then((val) => {
        this.$data.companytree = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  //保存
  save() {
    (this.$refs.itemModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "miniappconfig/update",
            data: this.entityPO,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        this.entityPO = new MiniAppConfigPO();
        this.entityPO.isEnable = 1;
        (this.$refs.itemModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
     if (!value) {
      this.$emit("input", value);
    } else {
      this.entityPO = Util.extend(true, {}, this.$store.state.miniappconfig.miniAppConfigItems);
    }
  }
  modelRule = {
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    miniAppName: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    appId: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    appSecret: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      companytree: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
